// src/hooks/useColorScheme.js
// ---------------------------------------------------------------------------
// "light" or "dark", following the phone, and staying correct if it changes.
//
// Reading matchMedia once at render is the version that looks right in testing
// and is wrong in use: iOS switches to dark on a schedule, and a guest who
// opened the code at 17:59 has the wrong plate behind the logo from 18:00
// onwards. The listener is three lines and removes the whole class of bug.
// ---------------------------------------------------------------------------
import { useEffect, useState } from "react";

const QUERY = "(prefers-color-scheme: dark)";

const read = () => {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia(QUERY).matches ? "dark" : "light";
};

export function useColorScheme() {
  const [scheme, setScheme] = useState(read);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setScheme(e.matches ? "dark" : "light");
    // addListener is the Safari 13 spelling. Still worth keeping: a guest's
    // phone is not a machine we get to choose.
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return scheme;
}
